/**
 * A `SearchSource` with no api behind it, for `/__ui/search` and the unit tests. Everything in
 * it is invented — no production name lands in the repo (CLAUDE.md rule 1).
 */
import type { SearchResultsView, SearchRowView, SearchSource } from './types';

const ROWS: SearchRowView[] = [
  { kind: 'board', id: '1000000000001', title: 'Sprint planning', snippet: 'Delivery board', boardId: '1000000000001', boardName: 'Sprint planning', itemId: null, state: 'active', updatedAt: '2026-09-09T10:00:00.000Z', href: '/boards/1000000000001', rank: 2.4 },
  { kind: 'board', id: '1000000000002', title: 'Sprint retro', snippet: '', boardId: '1000000000002', boardName: 'Sprint retro', itemId: null, state: 'active', updatedAt: '2026-09-08T10:00:00.000Z', href: '/boards/1000000000002', rank: 2.1 },
  { kind: 'item', id: '2000000000001', title: 'Sprint kickoff checklist', snippet: 'Working on it · High', boardId: '1000000000001', boardName: 'Sprint planning', itemId: '2000000000001', state: 'active', updatedAt: '2026-09-09T09:00:00.000Z', href: '/boards/1000000000001/pulses/2000000000001', rank: 1.9 },
  { kind: 'item', id: '2000000000002', title: 'Sprint budget', snippet: 'Done', boardId: '1000000000001', boardName: 'Sprint planning', itemId: '2000000000002', state: 'active', updatedAt: '2026-09-07T09:00:00.000Z', href: '/boards/1000000000001/pulses/2000000000002', rank: 1.4 },
  { kind: 'update', id: '3000000000001', title: 'Sprint kickoff checklist', snippet: 'Moved the sprint to next week.', boardId: '1000000000001', boardName: 'Sprint planning', itemId: '2000000000001', state: 'active', updatedAt: '2026-09-09T08:00:00.000Z', href: '/boards/1000000000001/pulses/2000000000001', rank: 1.1 },
  { kind: 'file', id: '4000000000001', title: 'sprint-plan.pdf', snippet: 'sprint-plan.pdf', boardId: '1000000000001', boardName: 'Sprint planning', itemId: '2000000000001', state: 'active', updatedAt: '2026-09-06T08:00:00.000Z', href: '/boards/1000000000001/pulses/2000000000001', rank: 0.8 },
  { kind: 'person', id: '5000000000001', title: 'Ada Sprint', snippet: 'ada@example.test', boardId: null, boardName: null, itemId: null, state: 'active', updatedAt: '2026-09-01T08:00:00.000Z', href: '/admin/users?user=5000000000001', rank: 0.7 },
];

const LABELS: Record<string, string> = {
  board: 'Boards', item: 'Items', update: 'Updates', file: 'Files', person: 'People',
};

export function createFixtureSearchSource(overrides: Partial<SearchSource> = {}): SearchSource {
  let recent = ['sprint', 'budget', 'kickoff'];
  return {
    async query(input): Promise<SearchResultsView> {
      const term = input.term.trim().toLowerCase();
      const kinds =
        input.category === 'cross_boards' ? ['board', 'item']
        : input.category === 'updates' ? ['update']
        : input.category === 'files' ? ['file']
        : input.category === 'people' ? ['person']
        : input.category === 'tags' || input.category === 'docs' ? []
        : ['board', 'item', 'update', 'file', 'person'];
      const matched = ROWS.filter(
        (row) => kinds.includes(row.kind) && (term.length === 0 || `${row.title} ${row.snippet}`.toLowerCase().includes(term)),
      );
      const groups = kinds
        .map((kind) => ({
          kind: kind as SearchRowView['kind'],
          label: LABELS[kind] ?? kind,
          total: matched.filter((row) => row.kind === kind).length,
          rows: matched.filter((row) => row.kind === kind),
        }))
        .filter((group) => group.total > 0);
      return { term: input.term, category: input.category, groups, total: matched.length, tookMs: 3 };
    },
    async recent() {
      return recent;
    },
    async remember(term) {
      recent = [term, ...recent.filter((value) => value !== term)].slice(0, 8);
    },
    async clearRecent() {
      recent = [];
    },
    ...overrides,
  };
}
